<template>
  <v-footer v-bind="$attrs" color="accent" class="p-footer">
    <v-col class="text-container">
      <p v-show="version" class="text">{{ systemName }} - v {{ systemVersion }}</p>

      <v-col v-for="link in links" v-bind:key="link.label" v-show="links">
        <v-subheader class="parent-link">
          {{ link.label }}
        </v-subheader>
        <v-subheader
          class="child-link"
          v-show="link.childLinks"
          v-for="childLink in link.childLinks"
          v-bind:key="childLink.label"
        >
          {{ childLink.label }}
        </v-subheader>
      </v-col>
    </v-col>

    <v-spacer />

    <v-col class="text-container" style="margin-right: 20px">
      <p class="text">© {{ new Date().getFullYear() }} Sicredi Pioneira RS</p>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: "p-footer",

  data() {
    return {
      systemName: process.env.VUE_APP_NAME,
      systemVersion: process.env.VUE_APP_VERSION
    };
  },

  props: {
    version: Boolean,
    links: Array,
  },
};
</script>

<style scoped>
@import "./styles.css";
</style>
